export interface AppCoachTrainingsCategoriesListFormRemove {
  id: string;
  organization_id: string;
  content: {
    name: string;
    fields: any;
  };
}

export class AppCoachTrainingsCategoriesListFormRemove implements AppCoachTrainingsCategoriesListFormRemove {
  id: string;
  organization_id: string;
  content: {
    name: string;
    fields: any;
  };

  constructor() {
    this.id = "";
    this.organization_id = "";
    this.content = {
      name: "",
      fields: [],
    };
  }
}